const NO_LETTERS_PATTERN = /^[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~\d\s]*$/;

export const hasNoLetters = (str: string): boolean =>
  NO_LETTERS_PATTERN.test(str);
